"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
exports.zipRegex = /((^\d{5}-\d{4}$)|(^\d{5}$))/;
